import React, { useEffect, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app, auth } from "../firebase/firebaseConfig";

export default function PhotoGallery({ folderItemId }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!folderItemId) return;
    let dead = false;
    (async () => {
      try {
        setLoading(true); setErr("");
        const fns = getFunctions(app, "europe-west2");
        const listImages = httpsCallable(fns, "spListImages");
        const { data } = await listImages({ folderItemId });
        if (!dead) setImages(data.images || []);
      } catch (e) {
        if (!dead) setErr(e.message || "Error");
      } finally {
        if (!dead) setLoading(false);
      }
    })();
    return () => { dead = true; };
  }, [folderItemId]);

  if (!folderItemId) return null;
  if (loading) return <p className="text-sm text-gray-500">Loading photos…</p>;
  if (err) return <p className="text-sm text-red-600">Images error: {err}</p>;
  if (!images.length) return <p className="text-sm text-gray-500">No photos yet.</p>;

  return (
    <div className="grid grid-cols-3 gap-2 mt-2">
      {images.map((img) => (
        <a key={img.id} href={img.webUrl} target="_blank" rel="noreferrer">
          <img
            src={img.thumbUrl || img.downloadUrl}
            alt={img.name}
            className="w-full h-24 object-cover rounded border"
            loading="lazy"
          />
        </a>
      ))}
    </div>
  );
}
